import { useFlags } from 'launchdarkly-react-client-sdk';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import useCustomerInitiativeView from './CustomerInitiativeView.hook';
import { mayaCustomerInitiativeListRoute } from 'basics/constants/routes.constants';
import { VeevaSyncStatus } from 'basics/enums/maya.enums';
import {
  FormLayoutContainer,
  FormLayoutMidPanel,
  FormLayoutMidPanelContent,
  FormLayoutMidPanelHeader,
  FormLayoutRightPanel,
} from 'components/FormLayout';
import Heading from 'components/Heading';
import InfoTag from 'components/InfoTag/InfoTag';
import MayaLayout from 'components/MayaLayout';
import VeevaStatusBar from 'components/VeevaStatusBar/VeevaStatusBar';
import {
  buttonStyle, headerWrapperStyle,
  sideContainerStyleFirstBox, sideContainerStyleInnerBox,
} from 'routes/AuthenticatedApp/CustomerInitiativeView/CustomerInitiativeView.styles';
import { ActionButton, ButtonVariant } from 'yoda-ui/components/BiogenLincDS/Buttons';
import Box from 'yoda-ui/components/Box';
import { Icons } from 'yoda-ui/components/Icons/Icon';
import Loader from 'yoda-ui/components/Loader';
import { YodaSpacing } from 'yoda-ui/yodaTheme';

const CustomerInitiativeView: FC = () => {
  const { t } = useTranslation();
  const {
    customerInitiative,
    date,
    productName,
    loading,
    navigate,
  } = useCustomerInitiativeView();

  const flags = useFlags();

  return (
    <MayaLayout>
      <FormLayoutContainer>
        <FormLayoutMidPanel >

          <FormLayoutMidPanelHeader>
          </FormLayoutMidPanelHeader>

          <FormLayoutMidPanelContent>
            <ActionButton
              label={ t('actions_back_label') }
              icon={ Icons.arrowBack }
              onClick={ () => { navigate(`${mayaCustomerInitiativeListRoute}?year=${customerInitiative?.year}`); } }
              variant={ ButtonVariant.primary }
              sx={ buttonStyle }
            />

            <Box sx={ headerWrapperStyle }>
              <Heading>
                { t('maya_ci_view') }
              </Heading>
              <VeevaStatusBar
                lastVeevaSync={ customerInitiative?.lastVeevaSync }
                lastVeevaSyncErrors={ customerInitiative?.lastVeevaSyncError ? [customerInitiative?.lastVeevaSyncError] : undefined }
                veevaSyncStatus={ customerInitiative?.veevaSyncStatus as VeevaSyncStatus }
              />
            </Box>

            {
              loading
                ? (
                  <Box display="flex" flexDirection="column" justifyContent="center" height="100%">
                    <Loader center />
                  </Box>
                )
                : (
                  <>
                    <Box>
                      <Box
                        sx={ sideContainerStyleFirstBox }
                        display="flex"
                        flexDirection="column"
                        justifyContent="space-between"
                        padding={ YodaSpacing.medium }
                      >
                        <Box>
                          <Box sx={ sideContainerStyleInnerBox } >
                            <InfoTag
                              title={ t('maya_ci_view_title') }
                              field={ customerInitiative?.title }
                            />
                            <InfoTag
                              title={ t('maya_ci_view_country') }
                              field={ customerInitiative?.country }
                            />
                            <InfoTag
                              title={ t('maya_ci_view_date') }
                              field={ date }
                            />
                            <InfoTag
                              title={ t('maya_ci_view_description') }
                              field={ customerInitiative?.description }
                            />
                            {
                              !flags.mayaAkma264RemovalOfUnusedFields ? (
                                <InfoTag
                                  title={ t('maya_ci_view_solution_core_story') }
                                  field={ customerInitiative?.solutionCoreStory }
                                />
                              ) : null
                            }
                            <InfoTag
                              title={ t('maya_ci_view_si') }
                              field={ customerInitiative?.strategicImperative.title }
                            />
                            <InfoTag
                              title={ t('maya_ci_view_therapeutic_area') }
                              field={ customerInitiative?.therapeuticArea }
                            />
                            <InfoTag
                              title={ t('maya_ci_view_product') }
                              field={ productName }
                            />
                            <InfoTag
                              title={ t('maya_ci_view_functional_owner') }
                              field={ customerInitiative?.functionalOwner }
                            />
                            <InfoTag
                              title={ t('maya_ci_view_functions_involved') }
                              field={ customerInitiative?.functionsInvolved.toString() }
                            />
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </>
                )
            }

          </FormLayoutMidPanelContent>

          <FormLayoutRightPanel>
          </FormLayoutRightPanel>

        </FormLayoutMidPanel>
      </FormLayoutContainer>
    </MayaLayout>
  );
};

export default CustomerInitiativeView;

